module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row color-row-4"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "txt-row-4"
  }, [_c('h3', [_vm._v("Se você deseja ter controle total sobre os custos e as recargas, este é o seu plano.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/adesao?planId=21",
      "tag": "button"
    }
  }, [_vm._v("\n          Quero este plano!\n        ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back",
    attrs: {
      "to": "/servicos-b2c"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v("\n        Voltar para planos\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-back pull-right",
    attrs: {
      "to": "/servicos-b2c-plano-conforto"
    }
  }, [_vm._v("\n        Ver próximo plano\n        "), _c('i', {
    staticClass: "icon-circle-right align-icon-right"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Serviços para Você")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("Plano Pré-pago Manual")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-1"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "txt-row-1"
  }, [_c('p', [_vm._v("Com o "), _c('b', [_vm._v("PRÉ-PAGO MANUAL")]), _vm._v(" você faz recargas e controla seu saldo para pegar a estrada.")]), _vm._v(" "), _c('p', [_vm._v("A recarga pode ser feita via app ou aqui no site da Move Mais.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "recharge-manual"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "payment-methods-control"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "txt-row-2"
  }, [_c('p', [_vm._v("A recarga pode ser feita via cartão de crédito.")]), _vm._v(" "), _c('p', [_vm._v("Nossa taxa é a "), _c('b', [_vm._v("menor do mercado")]), _vm._v(" e quanto maior o valor da recarga menor é a porcentagem da taxa de recarga.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row color-row-3"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "txt-row-3"
  }, [_c('span', [_vm._v("Você pode ainda consultar "), _c('b', [_vm._v("saldos")]), _vm._v(", "), _c('b', [_vm._v("extratos")]), _vm._v(" e "), _c('b', [_vm._v("geolocalização dos veículos")]), _vm._v(" diretamente no nosso site ou no app para mobile (Android e iOS).")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "gps-vehicle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "control-sheets"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-5c920c0a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/plan-prepay-manual-b2c.vue
// module id = 2141
// module chunks = 1